import { isIOS } from "Utils/Platform/PlatformUtils";

/**
 * Single source of truth for whether beta-related UI (drawer, logo chip,
 * sign-in explanation card, settings menu item, beta page) should be shown.
 *
 * Beta messaging is hidden inside the native iOS app (App Review / positioning),
 * but remains visible everywhere else (web, Android TWA/Capacitor).
 *
 * Change the condition here only — all consumers read from this function.
 */
export const getIsBetaVisible = () => !isIOS();
